import { clearModal } from '@hixme/modal'
import { connect } from 'react-redux'
import { getWaiter } from 'redux-waiter'

// route modules
import DeclineCoverageModal from 'components/DeclineCoverageModal/DeclineCoverageModal'
import withFeatureFlags from 'hocs/withFeatureFlags'
import { declineBundles } from '../actions'

const mapStateToProps = (state) => ({
  isProcessing: getWaiter(state, 'DECLINE_BUNDLES').isPending,
})

const mapDispatchToProps = (dispatch, props) => ({
  onCancelClick: () => dispatch(clearModal()),
  onDeclineClick: (_coveredPersons, _benefitProducts, _enrollmentKey, props) =>
    dispatch(declineBundles(props.declineForAll, props)),
})

export default withFeatureFlags(connect(mapStateToProps, mapDispatchToProps)(DeclineCoverageModal))
